import Title from '../Title';
import type { NodeBase } from '../../../../entities/Node';
import { HoverActions } from '../../HoverActions/HoverActions';
import { useHoverActions } from '../../HoverActions/useHoverActions';

const MultiSelect = ({ node }: { node: NodeBase }) => {
  const showHoverActions = useHoverActions(node);

  return (
    <>
      <Title title={node.title} />
      {showHoverActions && <HoverActions node={node} />}
    </>
  );
};

export default MultiSelect;
